import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './App.css';
import PageEN from './pagesEN';
import PagePT from './pagesPT';
import PrivacyPadrao from './PrivacyPadrao';

//update 2026-04-14

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RedirectToExternal />} />
        <Route path="/privacy-padrao" element={<PrivacyPadrao />} />
        <Route
          path="/google77bdd73ede744fc4.html"
          element={<GoogleVerification />}
        />
        {/* <Route path="/" element={<PageEN />} /> 
        <Route path="en" element={<PageEN />} /> 
        <Route path="pt" element={<PagePT />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

function RedirectToExternal() {
  useEffect(() => {
    window.location.href = 'https://lattes.cnpq.br/4548346554369389';
  }, []);

  return null;
}

function GoogleVerification() {
  return (
    <pre style={{ margin: 0, padding: 0, background: 'white', color: 'black' }}>
      google-site-verification: google77bdd73ede744fc4.html
    </pre>
  );
}


export default App;